import React, { Component } from 'react';


class NewQuoteForm extends Component {
  componentDidMount() {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        this.setCookie('hubspotutk', '', -1);
      }
    });
  }

  setCookie = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = `${name} = ${value} ;path=/;expires= ${d.toGMTString()}`;
  };

  render() {
    return (
      <div id="quote-form">
        <iframe
          src="https://forms.monday.com/forms/embed/e49bdbc88c0f9030b83362a83ada483b?r=euc1"
          width="100%"
          height="1080px"
          style={{ border: 0, backgroundColor: '#fffff' }}
        >
        </iframe>
      </div>
    );
  }
}

export default NewQuoteForm;
